// type CardType = 'Visa' | 'MasterCard' | 'Amex' | 'Discover' | 'Unknown';

export enum CardType {
	Visa = 'Visa',
	MasterCard = 'MasterCard',
	Amex = 'Amex',
	Discover = 'Discover',
	Unknown = 'Unknown',
}

export const detectCardType = (cardNumber: string): CardType => {
	if (/^4\d{12}(\d{3})?$/.test(cardNumber)) return CardType.Visa;
	if (/^5[1-5]\d{14}$/.test(cardNumber)) return CardType.MasterCard;
	if (/^3[47]\d{13}$/.test(cardNumber)) return CardType.Amex;
	if (/^6(?:011|5\d{2})\d{12}$/.test(cardNumber)) return CardType.Discover;
	return CardType.Unknown;
};

export const formatCardNumber = (cardNumber: string): string => {
	const cardType = detectCardType(cardNumber);

	switch (cardType) {
		case CardType.Amex:
			return cardNumber.replace(/(\d{4})(\d{6})(\d{5})/, '$1 $2 $3');
		case CardType.Visa:
		case CardType.MasterCard:
		case CardType.Discover:
			return cardNumber.replace(/(\d{4})(\d{4})(\d{4})(\d{1,4})/, '$1 $2 $3 $4');
		default:
			return cardNumber
				.replace(/\s+/g, '')
				.replace(/(\d{4})/g, '$1 ')
				.trim();
	}
};
